import { render, staticRenderFns } from "./DropdownSelect.vue?vue&type=template&id=10dcca96&scoped=true&"
import script from "./DropdownSelect.vue?vue&type=script&lang=js&"
export * from "./DropdownSelect.vue?vue&type=script&lang=js&"
import style0 from "./DropdownSelect.vue?vue&type=style&index=0&id=10dcca96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10dcca96",
  null
  
)

export default component.exports